const rowStyles = { rowGap: 10 }

export { rowStyles }
